<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-menu></app-menu>
</ion-app>
